import HomeStore from "./homeStore";
import CreateClass from "./createClass";
import TrainingSubjectManage from "./trainingSubjectManage";
let homeStore = new HomeStore();
let createClass = new CreateClass();
let trainingSubjectManage = new TrainingSubjectManage();
const stores = {
  homeStore,
  createClass,
  trainingSubjectManage
};
/// 默认导出接口
export default stores;
